import React from 'react';
import QuestionWrapper from '../../../../wrappers/question_wrapper';

import styles from './index.module.css';

export default function QuestionnaireStopper({
  header = 'Foo',
  para = 'Bar',
  onBack = () => {},
  showNavButtons = false,
  wide = false,
}) {
  return (
    <QuestionWrapper onSubmit={() => {}} isDisabled={true} onBack={onBack} showNavButtons={showNavButtons} wide={wide}>
      <div className={styles.thank_you_container}>
        <h3 className={styles.header_three} style={{ fontWeight: '700' }}>
          {header}
        </h3>
        <div className={styles.thank_you_text}>{para}</div>
      </div>
    </QuestionWrapper>
  );
}
